export default {
  Auto: '自動',
  Translate: '翻譯',
  Translating: '翻譯中',
  Results: '結果',
  Text_type: '文本類型',
  Length: '長度',
  Structure: '結構',
  Style: '風格',
  ai_translate: {
    des: '擷取資訊後的人工智慧翻譯',
    output: '👈在左侧输入要翻译的内容后，将自动为你翻译',
    input: '輸入您要翻譯的內容'
  }
}
